function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#626260;stroke-linecap:round;stroke-linejoin:round;stroke-width:11px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "contract"
}, /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 49,
  y1: 103.25,
  x2: 49,
  y2: 78.25
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 8.5,
  y1: 118.75,
  x2: 48.68,
  y2: 78.57
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 24,
  y1: 78.25,
  x2: 49,
  y2: 78.25
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 49,
  y1: 24.75,
  x2: 49,
  y2: 49.75
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 8.5,
  y1: 9.25,
  x2: 48.68,
  y2: 49.43
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 24,
  y1: 49.75,
  x2: 49,
  y2: 49.75
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 78.5,
  y1: 25.25,
  x2: 78.5,
  y2: 50.25
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 119,
  y1: 9.75,
  x2: 78.82,
  y2: 49.93
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 103.5,
  y1: 50.25,
  x2: 78.5,
  y2: 50.25
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 79,
  y1: 103.25,
  x2: 79,
  y2: 78.25
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 119.5,
  y1: 118.75,
  x2: 79.32,
  y2: 78.57
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 104,
  y1: 78.25,
  x2: 79,
  y2: 78.25
}));

function SvgIconFullscreenContractV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullscreenContractV2);
export default __webpack_public_path__ + "static/media/icon_fullscreen_contract_v2.5dfba739.svg";
export { ForwardRef as ReactComponent };